import { render } from "./CompetitionsListItem.vue?vue&type=template&id=3f5f10ac&scoped=true"
import script from "./CompetitionsListItem.vue?vue&type=script&lang=js"
export * from "./CompetitionsListItem.vue?vue&type=script&lang=js"

import "./CompetitionsListItem.vue?vue&type=style&index=0&id=3f5f10ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5f10ac"]])

export default __exports__